import { DateTime } from "luxon";
import { Tooltip } from "@mui/material";

import { Paragraph } from "../../../common/Atoms/Typography/Paragraph";

/** Date with the relative time underneath, so users don't have to work out what "13 days ago" was */
export function NoteTimestamp({ date }: { date: string | Date }) {
  const dateTime = DateTime.fromJSDate(new Date(date));

  return (
    <Tooltip title={ dateTime.toFormat(`yyyy-MM-dd HH:mm`) }>
      <div className={ `text-right shrink-0 whitespace-nowrap` }>
        <Paragraph>
          { dateTime.toFormat(`d LLLL yyyy`) }
        </Paragraph>
        <Paragraph
          variant={ `secondary` }
          size={ `xs` }
        >
          { dateTime.toRelative() }
        </Paragraph>
      </div>
    </Tooltip>
  );
}
